import type { ReactNode } from "react";
import {
  Activity,
  Bell,
  ClipboardList,
  Database,
  History,
  Home,
  LayoutDashboard,
  LayoutTemplate,
  Boxes,
  Layers,
  Network,
  Settings,
  Shield,
  SlidersHorizontal,
  Clock,
} from "lucide-react";
export const sectionIcons: Record<string, ReactNode> = {
  Home: <Home className="h-4 w-4" />,
  Inventory: <Boxes className="h-4 w-4" />,
  Integration: <Shield className="h-4 w-4" />,
  "Device Management": <Layers className="h-4 w-4" />,
  Dashboard: <LayoutDashboard className="h-4 w-4" />,
  Mapping: <Network className="h-4 w-4" />,
  Configuration: <Settings className="h-4 w-4" />,
  Modbus: <Network className="h-4 w-4" />,
  Alarms: <Bell className="h-4 w-4" />,
  Database: <Database className="h-4 w-4" />,
  Operations: <Activity className="h-4 w-4" />,
  Webhook: <Shield className="h-4 w-4" />,
  Report: <History className="h-4 w-4" />,
  Logs: <History className="h-4 w-4" />,
  "System Log": <ClipboardList className="h-4 w-4" />,
  "Rules Engine": <SlidersHorizontal className="h-4 w-4" />,
  Template: <LayoutTemplate className="h-4 w-4" />,
  "System Setting": <Settings className="h-4 w-4" />,
  Tools: <Clock className="h-4 w-4" />,
};
